import axios from 'axios'

const CardService = {

  async check (params = {}) {
    return axios.post('cards/check', params)
  },

  async register (params = {}) {
    return axios.post('cards/register', params)
  }
}

export default CardService
